import React from "react";
import {
  Upload,
  Form,
  Icon,
  Select,
  Button,
  Radio,
  Input,
  Col,
  DatePicker,
  TimePicker,
  Row, Checkbox,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "../PatientProfileForm/PatientProfileForm.css";
import get from "lodash/get";
import moment from "moment-timezone";
import { getUserTimezone, getUserShortTimezone } from "../../reducers/user/selectors";
import { connect } from "react-redux";

const { Option } = Select;

const fileDummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

class ConsentLhsStep3b extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    moment.tz.setDefault(
      this.props.userTimezone || get(this.props, "site.time_zone") || "UTC"
    );
  }

  render() {
    const props = this.props;

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>
            {props.i18n.t("NamespaceConsentLhsStep3b:Paper Consent Process")}
          </h4>
          <h5>
            {props.i18n.t("Site ID")}: <b>{props.siteID}</b>
          </h5>
          <h5>
            {props.i18n.t("User ID")}: <b>{props.userID}</b>
          </h5>
          <h5>
            {props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
          </h5>
          <h5>
            {props.i18n.t("Consent Type")}: <b>{props.consentPersonType}</b>
          </h5>
          <h5>
            {props.i18n.t("Consent Method")}: <b>{props.consentMethodType}</b>
          </h5>
        </div>

        <Form.Item>
          {props.form.getFieldDecorator("consentFile", {
            initialValue:
              props.dataset && props.dataset.filename
                ? props.dataset.filename
                : [],
            valuePropName: "fileList",
            getValueFromEvent: props.normFile,
            rules: [
              {
                required: props.consentPersonType === 'Emergency' ? !props.form.getFieldValue("consent_upload_later") : true,
                message: props.i18n.t(
                  "NamespaceConsentLhsStep3b:Please upload the consent file!"
                ),
              },
            ],
          })(
            <Upload
              id="consentFile"
              name="consentFile"
              customRequest={fileDummyRequest}
              accept=".pdf"
              allowClear
              size="large"
            >
              <Button>
                <Icon type="upload" /> {props.i18n.t("Upload Consent Form")}
              </Button>
            </Upload>
          )}
        </Form.Item>

        {props.consentPersonType === 'Emergency' && <Form.Item>
            {props.form.getFieldDecorator("consent_upload_later", {
            initialValue: false,
            valuePropName: "checked",
          })(
            <Checkbox onChange={() => { setTimeout(() => {props.form.validateFields()}, 0) }}>
              {this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Upload later"
              )}
            </Checkbox>
          )}
        </Form.Item>}

        <div>
          <Form.Item>
            <label>
              <div className="form-label">
                {props.i18n.t(
                  "NamespaceConsentLhsStep3b:Please check the appropriate box to indicate your decision"
                )}
                :
              </div>
              {props.form.getFieldDecorator("consent_option", {
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Radio.Group>
                  <Radio value="stay_in_study">
                    {props.i18n.t(
                      "NamespaceConsentLhsStep3b:I wish to stay in the study."
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study">
                    {props.i18n.t(
                      "NamespaceConsentLhsStep3b:I wish to withdraw from the study"
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study_allow_data_collection_via_linkage">
                    {props.i18n.t(
                      "NamespaceConsentLhsStep3b:I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage."
                    )}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Row gutter={8}>
            <Col md={24}>
              <label style={{ display: "block", textAlign: "left" }}>
                {this.props.i18n.t("Date and time*")}
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "4px",
                }}
              >
                <Form.Item>
                  <div style={{ width: "150px" }}>
                    {props.form.getFieldDecorator("consent_date_date", {
                      rules: [{ required: true, message: "Required" }],
                    })(
                      <DatePicker
                        format="YYYY/MM/DD"
                        placeholder="yyyy-mm-dd"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;
                <Form.Item>
                  <div style={{ width: "120px" }}>
                    {props.form.getFieldDecorator("consent_date_time", {
                      rules: [{ required: true, message: "Required" }],
                    })(
                      <TimePicker
                        format="HH:mm"
                        placeholder="HH:mm"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
                &nbsp;&nbsp;&nbsp;
                <Form.Item>
                  {this.props.userShortTimezone ||
                    get(this.props, "site.time_zone") ||
                    "UTC"}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>

        <Form.Item>
          <label>
            <div className="form-label">
              {props.i18n.t(
                "NamespaceConsentLhsStep3b:Has the consent form been completed by all parties? If no, please click on the Back button!"
              )}
            </div>
            {props.form.getFieldDecorator("consent_provided", {
              initialValue: props.consent_provided,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsentLhsStep3b:Has the consent form been completed by all parties?"
                  ),
                },
              ],
            })(
              <Select>
                <Option value="yes">{props.i18n.t("Yes")}</Option>
                <Option value="">{props.i18n.t("No")}</Option>
              </Select>
            )}
          </label>
        </Form.Item>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});

export default withNamespaces()(connect(mapStateToProps)(ConsentLhsStep3b));



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/ConsentLhsStep3b.js